import React from 'react';
import { Link, useHistory } from 'react-router-dom';
import logo_pop from '../assets/images/logo-pop.png';
import arrow_back from '../assets/images/arrow-back.svg';
import EDSFooter from '../components/EDSFooter';

const Login_error_key = () => {
    const key =  `/key/${localStorage.getItem('keyURL')}`;
    return (
        <>
            <header className="header">
                <div className="header__image-box">
                    <a href="">
                        <img
                            src={logo_pop}
                            alt="Logo Egurrola Dance Studio"
                            className="header__image"
                        />
                    </a>
                </div>
                <div className="header__caption-box">
                    <span className="header__caption">Proces zakupu kursu</span>
                </div>
            </header>
            <div className="content responsive-padding margin-top-32">
                <div>
                    <a href="">
                        <Link to={key}>
                            <img src={arrow_back} alt="arrow_back" className="arrow-back" />
                        </Link>
                    </a>
                </div>
                <main className="margin-top-64">
                    <div className="texts text-box">
                        <h2 className="h2">Błąd logowania </h2>
                        <p className="margin-top-16">Nie ma możliwości zakupu wybranej grupy w tym momencie. Prosimy o kontakt z Biurem Obsługi Klienta</p>
                        <p className="text-large margin-top-32">
                            Spróbuj zalogować się jeszcze raz.
                        </p>

                        <Link to={key}>
                            <a href="" className="btn-primary-responsive margin-top-16">
                                Przejdź do strony logowania
                            </a>
                        </Link>
                       
                        <div className="margin-top-32">
                            <h2 className="h2 margin-top-16">INFOLINIA</h2>
                            <p className="margin-top-8">czynna od poniedziałku do piątku</p>
                            <p>w godzinach 9:00 - 17:00</p>
                            <p className="margin-top-16">tel.: 601 20 20 20</p>
                            <p>e-mail: studio@egurrola.pl</p>
                        </div>
                        <Link to="/">
                            <a
                                href=""
                                className="btn-secondary-responsive btn-secondary-responsive--medium margin-top-64 margin-bottom-32"
                            >
                                Wróć do strony głównej
                            </a>
                        </Link>
                    </div>
                </main>
            </div>
            <EDSFooter></EDSFooter>
        </>
    );
};
export default Login_error_key;
